import { Fragment } from 'react';
import { DivisionLine, SubTitleTypography } from './ProductsList.styles';
import { RootDiv } from './ProductsList.styles';
import { InsuranceInfoMetadata, Order } from '@interfaces';
import { Item } from '@screens/checkout/paymentSuccess/components/Item';
import { extractShortDate, getWeekdayName, withoutTimezone } from '@utils';
import { usePermissions } from '@hooks/usePermissions';

interface ProductsListProp {
  isDelivery: boolean;
  orders: Order[];
  insuranceInfo: InsuranceInfoMetadata;
}

export function ProductsList({
  isDelivery,
  orders,
  insuranceInfo,
}: ProductsListProp) {
  const { userCan } = usePermissions();
  const isLocalVendor = userCan('LOCAL_VENDOR');

  const findDetailsWithInsurance = (orderDetails: Order['orderDetails']) => {
    return orderDetails.filter((detail) => {
      return detail.insurance;
    });
  };

  const findDetailsWithoutInsurance = (orderDetails: Order['orderDetails']) => {
    return orderDetails.filter((detail) => {
      return !detail.insurance;
    });
  };

  const userSelectedInsurance = insuranceInfo?.insuranceId;

  return (
    <RootDiv>
      {orders?.map((order, i) => (
        <Fragment key={order.id}>
          {isLocalVendor ? (
            <SubTitleTypography>Venta en Local</SubTitleTypography>
          ) : (
            <SubTitleTypography>
              {orders.length > 1
                ? `${isDelivery ? 'Entrega' : 'Retiro'} N° ${i + 1}: `
                : `${isDelivery ? 'Entrega' : 'Retiro'}: `}
              {`${getWeekdayName(
                order.deliveryDate.replace(/-/g, '/'),
              )} ${extractShortDate(
                withoutTimezone(order.deliveryDate.split(',')[0]),
              )}`}
            </SubTitleTypography>
          )}
          <DivisionLine />
          {findDetailsWithInsurance(order?.orderDetails).length > 0 &&
            userSelectedInsurance && (
              <>
                <SubTitleTypography>
                  Productos con cobertura de seguro
                </SubTitleTypography>
                <DivisionLine />
              </>
            )}
          {findDetailsWithInsurance(order?.orderDetails).map((detail) => {
            return (
              <Item
                key={`${detail.id}_${detail.price}_${detail.quantity}`}
                product={detail.product}
                price={detail.price}
                quantity={detail.quantity}
                loading={false}
                insurance={detail.insurance}
                type={detail.type ? String(detail.type) : null}
                listPrice={Number(detail.listPrice)}
              />
            );
          })}
          {findDetailsWithoutInsurance(order?.orderDetails).length > 0 &&
            userSelectedInsurance && (
              <>
                <SubTitleTypography>
                  Productos sin cobertura de seguro
                </SubTitleTypography>
                <DivisionLine />
              </>
            )}
          {findDetailsWithoutInsurance(order?.orderDetails).map((detail) => {
            return (
              <Item
                key={`${detail.id}_${detail.price}_${detail.quantity}`}
                product={detail.product}
                price={detail.price}
                quantity={detail.quantity}
                loading={false}
                insurance={detail.insurance}
                type={detail.type ? String(detail.type) : null}
                listPrice={Number(detail.listPrice)}
              />
            );
          })}
        </Fragment>
      ))}
    </RootDiv>
  );
}
